import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Card } from '@w7/ui'
import { bookmakerApi, bmErrorMessage } from '@/api/bookmaker'
import { BmJsonCard, BmPage } from './BmPage'

export function JodiMarketsViewPage() {
  const { id } = useParams()
  const [market, setMarket] = useState<unknown>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    void (async () => {
      if (!id) return
      try {
        setMarket(await bookmakerApi.marketGetOneJodi({ _id: id, id }))
      } catch (e) {
        setError(bmErrorMessage(e))
      }
    })()
  }, [id])

  return (
    <BmPage title={`Jodi Markets View ${id ?? ''}`} description="Lab /jodimarketsview/:id" error={error}>
      <Card>
        <Button
          onClick={() =>
            void bookmakerApi.marketJodiEdit({ _id: id, id }).catch((e) =>
              setError(e instanceof Error ? e.message : String(e)),
            )
          }
        >
          jodiMarketedit
        </Button>
      </Card>
      <BmJsonCard title="Jodi market" data={market} />
    </BmPage>
  )
}
